import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

function Techdevelopment(props) {
    return (
        <div className="tekrevol_development p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                        <div className="example" data-text="HRM Software">
                            <h2>HRM Software Development Services At TekRevol</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="offset-lg-1">
                        <h5 className="strong">With a full-stack approach toward custom HRMS software development,
                            TekRevol offers design and development services for these systems:</h5>
                        <div className="bulet_points">
                            <ul>
                                <li>Integrated complete Human Resource Management System</li>
                                <li>Employee Access Management system</li>
                                <li>Applicant tracking and onboarding systems</li>
                                <li>Internal HR app development for mobile and web</li>
                                <li>Cloud migration of existing HR solution</li>
                                <li>Employee database management system</li>
                                <li>Employee training, learning, and development system</li>
                            </ul>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Techdevelopment;